import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '@api';
import { putError, putSuccess } from '@utils/notificationUtils';

import { updateLocalProfile, updateProfile } from './profile.actions';
import { LoadersNames } from '../ui/ui.actions';
import { uiActions } from '../actions';

export function* updateProfileSaga({ payload }: ReturnType<typeof updateProfile.started>) {
  yield put(uiActions.showLoader(LoadersNames.fetchingData));
  const { id, password } = payload.value;
  try {
    const result = yield call(api.profile.profileUpdateMutation, payload.value);
    yield put(updateProfile.done({ params: payload, result }));
    if (password) {
      yield call(api.profile.changePasswordMutation, id, password);
      yield putSuccess('app:msg_title_changed', 'app:msg_password_changed');
    }

    yield putSuccess('app:msg_title_changed', 'app:msg_profile_updated');
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_updating_profile');
  }
  yield put(uiActions.hideLoader(LoadersNames.fetchingData));
}

export function* updateLocalProfileSaga({ payload }: ReturnType<typeof updateProfile.started>) {
  yield put(updateProfile.done({ params: payload, result: payload.value }));
  yield putSuccess('app:msg_title_changed', 'app:msg_profile_updated');

  if (payload.onSuccess) {
    payload.onSuccess();
  }
}

export function* watchProfileSaga() {
  yield all([
    yield takeLatest(updateProfile.started, updateProfileSaga),
    yield takeLatest(updateLocalProfile.started, updateLocalProfileSaga),
  ]);
}
